import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { arisanService } from '../services/api';
import './ArisanPages.css';

const ArisansListPage = () => {
  const [arisans, setArisans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchArisans();
  }, []);

  const fetchArisans = async () => {
    try {
      setLoading(true);
      const response = await arisanService.getAll();
      setArisans(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load arisans');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="page-container"><p>Memuat...</p></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>Arisan Saya</h2>
        <button onClick={() => navigate('/create-arisan')} className="btn-primary">
          + Buat Arisan Baru
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {arisans.length === 0 ? (
        <div className="empty-state">
          <p>Anda belum bergabung dengan arisan manapun.</p>
          <button onClick={() => navigate('/create-arisan')} className="btn-primary">
            Buat Arisan Pertama
          </button>
        </div>
      ) : (
        <div className="arisans-grid">
          {arisans.map(arisan => (
            <div key={arisan._id} className="arisan-card">
              <div className="card-header">
                <h3>{arisan.name}</h3>
                <span className={`status ${arisan.status}`}>{arisan.status === 'active' ? 'Aktif' : 'Tidak Aktif'}</span>
              </div>
              <div className="card-body">
                {arisan.description && <p className="description">{arisan.description}</p>}
                <div className="card-info">
                  <div className="info-item">
                    <span className="label">Iuran Bulanan:</span>
                    <span className="value">Rp {arisan.monthlyAmount.toLocaleString('id-ID')}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Anggota:</span>
                    <span className="value">{arisan.totalMembers}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Siklus:</span>
                    <span className="value">{arisan.cycle} bulan</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Tanggal Mulai:</span>
                    <span className="value">{new Date(arisan.startDate).toLocaleDateString('id-ID')}</span>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button 
                  onClick={() => navigate(`/arisan/${arisan._id}`)}
                  className="btn-view"
                >
                  Lihat Detail
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArisansListPage;
